import { Button, HStack, Stack, Text, useToast } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

interface Props {
  onSendCode: () => Promise<void>;
  onContinue: () => void;
}

const RESEND_SECONDS = 60;

export function ContractStepIdentity({ onSendCode, onContinue }: Props) {
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [resendIn, setResendIn] = useState(0);
  const toast = useToast();

  useEffect(() => {
    if (resendIn <= 0) return;
    const t = setInterval(() => setResendIn((s) => Math.max(0, s - 1)), 1000);
    return () => clearInterval(t);
  }, [resendIn]);

  const handleSend = async () => {
    setSending(true);
    try {
      await onSendCode();
      setSent(true);
      setResendIn(RESEND_SECONDS);
      toast({ title: 'Código enviado para seu email', status: 'success', duration: 3000 });
    } catch (err: any) {
      toast({
        title: 'Erro',
        description: err?.response?.data?.message || 'Não foi possível enviar o código',
        status: 'error',
        duration: 5000,
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <Stack spacing={4}>
      <Text>Para confirmar sua identidade, vamos enviar um código de 6 dígitos para o seu email.</Text>
      <HStack>
        <Button
          onClick={handleSend}
          isLoading={sending}
          isDisabled={resendIn > 0}
          colorScheme="blue"
        >
          {sent ? (resendIn > 0 ? `Reenviar em ${resendIn}s` : 'Reenviar código') : 'Enviar código'}
        </Button>
        <Button variant="ghost" onClick={onContinue} isDisabled={!sent}>
          Já recebi → continuar
        </Button>
      </HStack>
    </Stack>
  );
}
